import { TaxEstimateFilingStatus } from "@wingspanhq/wingspan-api-sdk";
import {
  HEAD_OF_HOUSEHOLD_OPTIONS,
  MARRIED_OPTIONS,
  SINGLE_OPTIONS
} from "../../../constants/user";

/**
 * The expected-income bands offered for a filing status, as select options.
 *
 * The bands are v1's and each maps to the single figure sent as
 * `estimatedAnnualIncome`; the value is stringified because select options are
 * strings.
 */
export const selectorIncomeOptionsByFilingStatus = (
  filingStatus?: TaxEstimateFilingStatus
) => {
  const bands =
    filingStatus === TaxEstimateFilingStatus.MARRIED_FILING_JOINTLY
      ? MARRIED_OPTIONS
      : filingStatus === TaxEstimateFilingStatus.HEAD_OF_HOUSEHOLD
        ? HEAD_OF_HOUSEHOLD_OPTIONS
        : SINGLE_OPTIONS;

  return bands.map(band => ({
    value: String(band.value),
    label: band.label
  }));
};
